import React from 'react'
import classNames from 'classnames'

import { Grid, createStyles, WithStyles, withStyles, ButtonBase, Typography, Theme } from '@material-ui/core'
import { IQuizAnswer } from 'protos'

interface Props {
  readOnly?: boolean
  answers: IQuizAnswer[]
  selectedAnswerId?: string | null
  selectedColor?: 'primary' | 'error'
  onAnswerChange?: (answerId: string) => void
}

const styles = (theme: Theme) => createStyles({
  root: {
    padding: theme.spacing(),
  },
  choice: {
    margin: theme.spacing(),
    backgroundColor: theme.palette.grey[50],
    borderRadius: 5,
    border: `1px solid ${theme.palette.grey[200]}`,
    display: 'block',
    padding: `${theme.spacing()}px 0`,
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.dark,
  },
  error: {
    backgroundColor: theme.palette.error.main,
    borderColor: theme.palette.error.dark,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

function preventPropagation(e: React.MouseEvent) {
  e.preventDefault()
  e.stopPropagation()
}

const QuizChoices: React.SFC<InjectedProps> = ({
  classes,
  answers,
  selectedColor,
  selectedAnswerId,
  readOnly,
  onAnswerChange,
}) => (
    <Grid container className={classes.root}>
      {answers.map((answer, i) => {
        const isSelected = selectedAnswerId === answer.answerId
        const className = classNames(
          classes.choice,
          {
            [classes.primary]: isSelected && selectedColor === 'primary',
            [classes.error]: isSelected && selectedColor === 'error',
          },
        )

        const onAnswerClick = (e: React.MouseEvent) => {
          e.preventDefault()
          e.stopPropagation()

          if (onAnswerChange && answer.answerId && !isSelected) {
            onAnswerChange(answer.answerId)
          }
        }

        return (
          <Grid item xs key={i}>
            <ButtonBase
              disabled={readOnly}
              component="div"
              className={className}
              onClick={onAnswerClick}
              onMouseDown={preventPropagation}
            >
              <Typography align="center" variant="body1">
                {answer.shortText}
              </Typography>
            </ButtonBase>
          </Grid>
        )
      })}
    </Grid>
  )

export default withStyles(styles)(QuizChoices)
